import { Spin, Table } from 'antd';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import {
  bool, object,
} from 'prop-types';
import { isEmpty, isNumber, isUndefined } from 'lodash';
import FilterType from '@/components/FilterType/FilterType';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import './PublicList.less';
import { getAgriculturalPublicList } from '@/services/agriculturalSubsidies';

const startYear = 2024;
const endYear = new Date().getFullYear(); // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});

/**
 * 公示名单
 * @param {object} data 数据源
 * @param {bool} filter 是否显示筛选条件
 * */
export default function PublicList({
  data, filter,
}) {
  const [list, setList] = useState({});
  const [val, setVal] = useState({});

  const { run, loading } = useRequest(getAgriculturalPublicList, { // 公示列表
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    const { regionVo } = e;
    run({ ...e, ...regionVo });
  }

  function onChange(page, size) {
    getData({ ...val, pageNum: page, pageSize: size });
  }

  function handleFilter(arr, t) {
    let obj = { ...val };
    if (t === 'cityCode') {
      if (arr) {
        obj = { ...obj, regionVo: { cityCode: arr[0] } };
      } else {
        obj = { ...obj, regionVo: {} };
      }
      setVal(obj);
      getData(obj);
    } else {
      obj = { ...val, [t]: isUndefined(arr) ? null : arr[0] };
      setVal(obj);
      getData(obj);
    }
  }

  function tableTitle() {
    const { year } = val;
    return (
      <div style={{ fontSize: '20px', fontWeight: 600, textAlign: 'center' }}>
        {isNumber(year) ? `${year}年` : ''}
        农产品加工补贴情况公示表
      </div>
    );
  }

  const columns = [
    {
      title: '市州',
      dataIndex: 'cityCode',
      align: 'center',
    },
    {
      title: '区县',
      dataIndex: 'areaCode',
      align: 'center',
    },
    {
      title: '年度',
      dataIndex: 'year',
      align: 'center',
    },
    {
      title: '企业名称',
      dataIndex: 'projectUnit',
      align: 'center',
    },
    {
      title: '补助金额（万元）',
      dataIndex: 'subsidyAmount',
      align: 'center',
    },
    {
      title: '公示单位联系电话',
      dataIndex: 'publicationTel',
      align: 'center',
    },
  ];

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        <span className="pl-filter-title">筛选条件</span>
        {
          filter && (
            <div className="product-filter">
              <FilterType title="申报年度" titleWidth={88} data={years} radio onChange={(e) => handleFilter(e, 'year')} />
              {
                !isEmpty(data?.area) && (
                  <FilterType title="申报区域" titleWidth={88} data={data?.area} radio onChange={(e) => handleFilter(e, 'cityCode')} />
                )
              }
            </div>
          )
        }
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              <Table
                title={tableTitle}
                columns={columns}
                rowKey="id"
                dataSource={list?.items}
                scroll={{ x: 1000 }}
                pagination={{
                  onChange,
                  current: list?.pageNum,
                  total: list?.totalRows,
                }}
              />
            </div>
          )
        }
      </Spin>
    </div>
  );
}

PublicList.propTypes = {
  filter: bool,
  data: object,
};

PublicList.defaultProps = {
  filter: true,
};
